import { useEffect, useState } from 'react';

import { getTimeAndDate } from '@/utils/helpers';

import { ArticlesRefreshStatus } from './ArticlesSection.types';

const RELATIVE_TIME_TICK_MS = 1_000;

const formatUpdatedAgo = (refreshUpdatedAt: string): string => {
  const elapsedSeconds = Math.max(
    0,
    Math.floor((Date.now() - new Date(refreshUpdatedAt).getTime()) / 1000)
  );

  if (elapsedSeconds < 60) {
    return `Updated ${elapsedSeconds}s ago`;
  }

  return `Updated ${getTimeAndDate({
    dateStr: refreshUpdatedAt,
    fromNow: true,
    fromNowSuffix: true,
  })}`;
};

export const useRefreshStatusLabel = (
  status: ArticlesRefreshStatus,
  refreshUpdatedAt: string | null
): string | null => {
  const [, setRelativeTimeTick] = useState(0);

  useEffect(() => {
    if (status !== 'success' || !refreshUpdatedAt) {
      return;
    }

    const intervalId = setInterval(() => {
      setRelativeTimeTick(tick => tick + 1);
    }, RELATIVE_TIME_TICK_MS);

    return () => clearInterval(intervalId);
  }, [status, refreshUpdatedAt]);

  switch (status) {
    case 'loading':
      return 'Updating...';
    case 'success':
      return refreshUpdatedAt ? formatUpdatedAgo(refreshUpdatedAt) : null;
    case 'failure':
      return 'Update failure';
    default:
      return null;
  }
};
